const appRoles: string[] = [
    "ANONYMOUS", "ADMIN", "MOD", "MEMBER"
]

export default appRoles;